import React from 'react';
import { Link } from 'react-router-dom';
import { companyLabel, GRUPO, fmtDate } from '../client360/c360Shared';
import { mesCurto, mesLabel } from './com360Shared';

const EST = {
  concluido: { label: 'Concluídos', cls: 'bg-emerald-100 text-emerald-800' },
  em_curso: { label: 'Em curso', cls: 'bg-sky-100 text-sky-800' },
  anulado: { label: 'Anulados', cls: 'bg-slate-200 text-slate-600' },
};

const History = ({ hist, meta }) => {
  const max = Math.max(meta || 0, ...hist.map((h) => h.feitos), 1);
  return (
    <div className="flex items-end gap-2 h-28" data-testid="com360-history">
      {hist.map((h) => (
        <div key={h.mes} className="flex-1 flex flex-col items-center gap-1">
          <span className="text-xs font-bold text-slate-700">{h.feitos}</span>
          <div className="w-full rounded-t-md bg-[#4DD4E8]" style={{ height: `${(70 * h.feitos) / max + 2}px` }} />
          <span className="text-[10px] uppercase text-slate-500">{mesCurto(h.mes)}</span>
        </div>
      ))}
    </div>
  );
};

export const MonthContracts = ({ data, month, hist, meta }) => (
  <div className="grid gap-4 lg:grid-cols-[1fr_320px]">
    <div className="rounded-2xl border border-slate-200 bg-white p-4 space-y-3" data-testid="com360-contracts">
      <div className="flex flex-wrap items-center gap-2">
        <h2 className="text-base md:text-lg font-bold font-[Outfit] text-[#2D3E6F] flex-1">Contratos de {mesLabel(month)} ({data.total})</h2>
        {Object.entries(EST).map(([k, v]) => (
          <span key={k} className={`text-xs font-semibold px-2.5 py-0.5 rounded-full ${v.cls}`} data-testid={`com360-est-${k}`}>{v.label}: {data.estados[k] || 0}</span>
        ))}
      </div>
      <div className="flex flex-wrap gap-2">
        {Object.entries(data.por_servico).map(([g, n]) => (
          <span key={g} className={`text-xs px-2 py-0.5 rounded-full border ${GRUPO[g]?.cls}`}>{GRUPO[g]?.label || g}: {n}</span>
        ))}
      </div>
      {data.lista.length === 0 ? <div className="text-sm text-slate-400 py-6 text-center">Sem contratos neste mês.</div> : (
        <div className="divide-y divide-slate-100 max-h-80 overflow-y-auto">
          {data.lista.map((c) => (
            <Link key={c.id} to={`/contracts/${c.service_category || 'luz_gas'}/${c.company}/${c.id}`} data-testid={`com360-contract-${c.id}`}
              className="flex items-center gap-3 py-2 text-sm hover:bg-slate-50 px-1 rounded">
              <span className="font-mono text-xs text-slate-500 w-20 shrink-0">{c.codigo || '—'}</span>
              <span className="flex-1 truncate font-medium">{c.nome_cliente}</span>
              <span className="text-xs text-slate-500">{companyLabel(c.company)}</span>
              <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full ${EST[c.estado_grupo]?.cls}`}>{EST[c.estado_grupo]?.label.replace(/s$/, '')}</span>
              <span className="text-xs text-slate-400 w-20 text-right">{fmtDate(c.created_at)}</span>
            </Link>
          ))}
        </div>
      )}
    </div>
    <div className="rounded-2xl border border-slate-200 bg-white p-4 space-y-3">
      <h2 className="text-base md:text-lg font-bold font-[Outfit] text-[#2D3E6F]">Últimos 6 meses</h2>
      <History hist={hist} meta={meta} />
      {meta > 0 && <p className="text-xs text-slate-500">Meta atual: {meta} contratos/mês</p>}
    </div>
  </div>
);
